import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './Components/Layout/layout.component';
import { LoginComponent } from './Components/Authentication/Login/login.component';

const routes: Routes = [
  // { path: '', pathMatch: 'full', redirectTo: '/welcome' },
  // { path: '/login', pathMatch: 'full', component: LoginComponent },
  { path: 'layout', pathMatch: 'full', component: LayoutComponent },
  { path: 'dashborad', pathMatch: 'full', component: LayoutComponent },
  // { path: 'client', pathMatch: 'full', component: LayoutComponent },
  // { path: 'applications', pathMatch: 'full', component: LayoutComponent },
  { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) },
  { path: 'applications', loadChildren: () => import('./pages/application/applications.module').then(m => m.ApplicationsModule) },
  { path: 'client', loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule) },
  { path: 'environments', loadChildren: () => import('./pages/environments/environments.module').then(m => m.EnvironmentsModule) },
  { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
